import { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";

import * as APIModels from "../../../../../models";

import { UserService } from "../../../../../services/ClientService";
//import {  }

export type SendModalProps = {
    show: boolean;
    organizationId: string;
    onClose: () => void;
};

export default function SendModal({
    show,
    organizationId,
    onClose,
}: SendModalProps): JSX.Element {
    const [emailAddress, setEmailAddress] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        //
    });

    const closeWindow = () => {
        setEmailAddress("");
        onClose();
    };

    const sendEmail = async (): Promise<boolean> => {
        const request = new APIModels.RegistrationEmailRequest();
        let ret = false;
        request.email = emailAddress;
        request.organizationId = organizationId;
        console.log(request);
        await UserService.sendEmail({
            body: request,
        }).then(
            (res) => {
                if (res.successful === true && res.data) {
                    ret = true;
                } else {
                    setErrorMessage(res.errorMessage ?? "");
                }
            },
            (error) => {
                setErrorMessage(error);
            }
        );
        return ret;
    };

    return (
        <Modal
            show={show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Registration
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row form-group m-2">
                    <div className="col-sm-6">
                        <label>EmailAddress</label>
                        <input
                            className="form-control"
                            id="SendEmail"
                            type="text"
                            value={emailAddress}
                            onChange={(event) => {
                                setEmailAddress(event.currentTarget.value);
                            }}
                        />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <label style={{ float: "left", color: "red" }}>
                    {errorMessage}
                </label>
                {emailAddress !== "" && (
                    <Button
                        className="btn-primary"
                        onClick={() => {
                            sendEmail().then((res) => {
                                if (res === true) {
                                    closeWindow();
                                }
                            });
                        }}
                    >
                        Send
                    </Button>
                )}
                <Button className="btn-danger" onClick={closeWindow}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
